module.exports = __webpack_public_path__ + "img/six_step.b93bceb2.png";